<div class="main" color="primary" *ngIf="!hide">
    <span>© brAInwatch 2023</span>
</div>